import { connect } from 'react-redux';
import {
  modal as modalActions,
  updateCaseAmendingBaseline
} from './../actions';

import BaselineUpdateComponent from './../Components/BaselineUpdateComponent.jsx';

export const mapStateToProps = undefined;

export const mapDispatchToProps = (dispatch) => ({
  onSubmit: baselineInfo => {
    dispatch(updateCaseAmendingBaseline(
      baselineInfo.imageName, baselineInfo.jobType, baselineInfo.number));
    dispatch(modalActions.showCaseAmendingBaselineUpdateModal(false, ''));
  }
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BaselineUpdateComponent);


// WEBPACK FOOTER //
// src/Containers/BaselineUpdateContainer.jsx